<template>
  <div>
    <router-link tag="div" class="MBlock"
      :class="{ NotPublished: !card.visible }"
      :to="link(card)"
      v-for="card in cards"
      :key="card.id"
    >
      <component :is="showLink(card) ? 'a' : 'span'">
        <div class="MPict" :style='{ backgroundImage: `url(${card.pict_preview})` }'></div>
        <div class="WBlock">
          <div class="Markers">
            <img class="MP" v-for="tag_id in card.tag_ids" :src="`/img/fpd-${tag_id}.png`">
          </div>
          <div class="MName">{{ card.name_big }}</div>
          <div class="VName">{{ card.name_small }}</div>
          <div class="MyIcon" v-if="authorized && isFavoriteCard(card)"></div>
        </div>
        <div class="GBlock">
          <div class="People">{{ card.people }}</div>
          <div class="Hours">{{ card.time }}</div>
        </div>
        <div class="IBlock">{{ card.announcement }}</div>
      </component>
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    cards: Array,
  },
  methods: {
    isFavoriteCard(card) {
      return this.currentUser.favorite_card_ids.includes(card.id);
    },
    showLink(card) {
      if (card.visible) {
        return true;
      } else {
        return this.currentUser.role == 'admin' || card.author_id == this.currentUser.id;
      }
    },
    link(card) {
      return this.showLink(card) ? this.to('card', { id: card.id }) : '';
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'authorized']),
  },
};
</script>

<style>
.NotPublished{
  opacity: 0.6;
}

.NotPublished:hover{
  opacity: 1;
}

.Fraza{
  position: relative;
  margin: 40px auto;
  width: 600px;
  height: 30px;
  text-align: center;
  font-family: 'Caveat', sans-serif;
  font-size: 36px;
  color: #37bbd6;
}
.MBlock{
  position: relative;
  /* float: left; */
  margin: 10px;
  width: 280px;
  height: 400px;
  text-align: left;
  border: 0px solid #cccccc;
  display: inline-table;
  clear: both;
}
.MBlock a{
  text-decoration: none
}

.MPict{
  position: relative;
  width: 280px;
  height: 160px;
  border: 0px solid #cccccc;
  background-repeat: no-repeat;
  background-size: cover;
}

.WBlock{
  position: relative;
  width: 280px;
  padding-top: 5px;
  padding-bottom: 15px;
  min-height: 115px;
  background-color: #FFF;
}

.Markers{
  margin-left: 10px;
  height: 30px;
}

.MyIcon{
  position: absolute;
  right: 6px;
  top: 11px;
  padding-right: 16px;
  padding-top: 2px;
  font-family: 'Open Sans', sans-serif;
  font-size: 10px;
  color: #b6b6b6;
  width: 15px;
  height: 15px;
  border: 0px solid #cccccc;
  background-image: url("/img/take-icon-on.png");
  background-size:contain;
  background-repeat: no-repeat;
  background-position: right top;
}

.MP{
  width: 26px;
  height: 26px;
  padding-right: 10px;
  cursor: pointer;
}

.MName{
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 5px;
  /* font-family: 'Oswald', sans-serif; */
  font-family: 'Roboto Condensed', sans-serif;
  color: #000;
  font-weight: bold;
  font-size: 26px;
  line-height: 1.1;
}

.VName{
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 3px;
  font-family: 'Roboto Condensed', sans-serif;
  color: #808080;
  font-weight: 400;
  font-size: 16px;
}

.GBlock{
  position: relative;
  width: 280px;
  min-height: 15px;
  padding-bottom: 5px;
  background-image: url("../assets/img/shadow-small.png");
  background-position: right top;
  background-repeat: no-repeat;
}

.People{
  min-height: 22px;
  margin-left: 13px;
  padding-top: 17px;
  padding-left: 28px;
  font-family: 'Roboto Condensed', sans-serif;
  color: #808080;
  font-weight: 400;
  font-size: 16px;
  background-image: url("../assets/img/icon-24x24-1.png");
  background-position: 0px 15px;
  background-repeat: no-repeat;
}

.Hours{
  min-height: 22px;
  margin-left: 13px;
  font-family: 'Roboto Condensed', sans-serif;
  color: #808080;
  font-weight: 400;
  font-size: 16px;
  padding-top: 4px;
  padding-left: 28px;
  padding-bottom: 4px;
  background-image: url("../assets/img/icon-24x24-2.png");
  background-position: left top;
  background-repeat: no-repeat;
}

.IBlock{
  position: relative;
  padding-top: 0;
  padding-left: 15px;
  padding-right: 20px;
  padding-bottom: 40px;
  font-family: 'Open Sans', sans-serif;
  color: #6d6d6d;
  font-size: 13px;
  border-top: 0px solid #cccccc;
}
</style>
